import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem, apiPath } from '@/constants/defaultValues';
import { Get } from '@/api/api-middleware';
import { getLabel } from '@/helpers/Utils';

const initialState = {
  formList: [],
  controlList: [],
  formByWorkFlowItem: {},
  loading: false,
  error: '',
};

export const fetchForm = createAsyncThunk(
  'form/fetchForm',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetForms();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.formID,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: item.name,
          value: item.formID,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getFormByWorkFlowId = createAsyncThunk(
  'form/getFormByWorkFlowId',
  async (params, thunkAPI) => {
    try {
      const response = await Get({
        url: `${apiPath}api/Lookup/PermissionType/GetByID/${params}`,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchForm.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchForm.fulfilled, (state, action) => {
        state.loading = false;
        state.formList = action.payload;
        state.error = '';
      })
      .addCase(fetchForm.rejected, (state, action) => {
        state.loading = false;
        state.formList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(getFormByWorkFlowId.pending, (state) => {
        state.loading = true;
        state.formByWorkFlowItem = {};
      })
      .addCase(getFormByWorkFlowId.fulfilled, (state, action) => {
        state.loading = false;
        state.formByWorkFlowItem = action.payload;
        state.error = '';
      })
      .addCase(getFormByWorkFlowId.rejected, (state, action) => {
        state.loading = false;
        state.formByWorkFlowItem = {};
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default formSlice.reducer;
